import { Component, OnInit, ElementRef, HostListener } from '@angular/core';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../service/api.service';
import { Router } from "@angular/router"
import { CoreService } from '../../service/core.service';

@Component({
  selector: 'app-fuji-billing-sidebar',
  templateUrl: './fuji-billing-sidebar.component.html',
  styleUrls: ['./fuji-billing-sidebar.component.css']
})
export class FujiBillingSidebarComponent implements OnInit {

  search_res: any[];
  token: string;
  display_name: String;
  eInvoiceSupport: boolean = false;
  eInvoiceSupportAdmin: boolean = false;
  branch_name: String;
  display_code: String;
  branch_e_invoice_enabled = 0;
  user_name: String;
  photo: any;
  base_url: string;
  usr_username: any;
  // headerSalesEinvoiceLink=0;
  search_inp: any;
  show_production = false;
  cheq_issue_date: Date = new Date();
  pdc_count: any;
  batch_ex_count: any;
  admin_notification: any;
  up: any;
  checkBatch = false;
  so_count = <any>0;
  userType: any;
  show_component: boolean;
  user_id: any;
  einvoice_count: any;
  show_documentation = false;
  cmpny = '';
  saledue_count = <any>0;
  purchasedue_count = <any>0;
  invrequest_count: any = 0;
  invrequest_list: any;
  status = {
    '0': 'Pending',
    '1': 'Approved',
    '2': 'Rejected',
  };
  list_all: any;


  is_rest_pos_enabled = false;
  cmp_tax: any;
  isFujiiBillingEnabled = true;

  constructor(config: NgbModalConfig, private modalService: NgbModal, public translate: TranslateService,
    private apiService: ApiService, public router: Router, private coreService: CoreService, private eRef: ElementRef) {
    // customize default values of modals used by this component tree
    config.backdrop = 'static';
    config.keyboard = false;

    // translation
    translate.addLangs(['English', 'Chinese', 'Arabic', 'French']);

    if (sessionStorage.getItem("baseLang")) {
      translate.use(sessionStorage.getItem("baseLang"));
    } else {
      translate.use('English');
    }

    this.apiService.notificationChange.subscribe(value => {
      this.pdc_count = value;
    })
    this.apiService.salesordernotificationChange.subscribe(value => {
      this.so_count = value;
    });
    this.apiService.salesduenotificationChange.subscribe(value => {
      this.saledue_count = value;
    });
    this.apiService.purchaseduenotificationChange.subscribe(value => {
      this.purchasedue_count = value;
    });
    this.apiService.notificationBatchChange.subscribe(value => {
      this.batch_ex_count = value;
    })

    this.apiService.pendingEinvoiceNotificationChange.subscribe(value => {
      this.einvoice_count = value;
    })
    this.apiService.invoiceRequestChange.subscribe(value => {
      this.invrequest_count = value.count;
      this.invrequest_list = value.list;
      console.log('value');
      console.log(value);

    })


  }

  open(content) {
    this.modalService.open(content);
  }

  ngOnInit() {

    this.userType = this.coreService.getUserData('user_type');
    this.user_id = this.coreService.getUserData('usr_id');
    this.branch_e_invoice_enabled = this.coreService.getUserData('is_e_invoice');
    this.cmp_tax = this.coreService.getUserData('cmpny_tax');
    this.apiService.getClientSettingBykey({ key: 'enable_e_invoice' }).subscribe((res) => {
      if (res['data']) {
        this.eInvoiceSupport = ((res['data']['cs_value'] ? true : false) && this.branch_e_invoice_enabled) ? true : false;
        this.eInvoiceSupportAdmin = ((res['data']['cs_value'] ? true : false) && this.userType == 'ADMIN') ? true : false;
      }
    });

    this.apiService.getClientSettingBykey({ key: 'Batch Support' }).subscribe((res) => {
      if (res['data']) {
        this.checkBatch = (res['data']['cs_value']) ? true : false;
      }
    });
    this.apiService.getAllClientSettings().subscribe((res) => {
      this.is_rest_pos_enabled = (res.data.enable_restaurant_pos.cs_value) ? res.data.enable_restaurant_pos.cs_value : 0;
    })
    this.base_url = this.apiService.PHP_API_SERVER;
    this.show_component = true;
    this.photo = this.apiService.S3_SERVER + '/uploads/user/' + this.coreService.getUserData('photo');
    this.getEnbaleDisableModuleSettingBykey();
    if (!localStorage.getItem("auth_token")) {
      this.router.navigate(['/']);
    }

    this.apiService.updatePDCNotification();
    this.apiService.updateSalesOrderNotification();
    this.apiService.updatebatchExNotification();
    this.apiService.updateEinvoiceNotificationChange();
    this.apiService.updateSalesDueNotification();
    this.apiService.updatePurchaseDueNotification();
    this.apiService.updateInvoiceRequest('');
    this.loadDisplayUserData();
    this.router.events.subscribe(() => {
      this.loadDisplayUserData();
    });
    if (this.admin_notification) {
      $("#adminNtfnMdl").click();
    }
  }
  onNotificationClick() {
    this.apiService.updateInvoiceRequest('');
  }
  refreshBtn() {
    const searchval = {
      'list_all': this.list_all,
    }

    this.apiService.updateInvoiceRequest(searchval);

  }
  requestApprv(id, status, msg) {
    if (confirm('Do you wish to ' + msg + ' this request?')) {

      const searchval = {

        'sia_id': id,
        'status': status,
      }
      this.apiService.updateInvReqStatus(searchval).subscribe((res) => {
        this.coreService.showMessage(res.message);
        this.apiService.updateInvoiceRequest('');
      });
    }
  }
  getEnbaleDisableModuleSettingBykey() {
    this.apiService.getEnbaleDisableModuleSettingBykey().subscribe((res) => {
      if (res['data']) {
        this.show_production = (res['data']['enable_production']) ? true : false;
        this.show_documentation = (res['data']['enable_documentation']) ? true : false;
      }
    });
  }

  selDefault(lang) {
    alert("lang");
  }

  changeLang(bLang) {
    this.translate.use(bLang);
    sessionStorage.setItem("baseLang", bLang);
    this.apiService.updateLanguage();
  }

  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      $('.search-list').hide();
    }
  }

  searchMenu(search: string) {
    if (search && search.trim() !== '') {
      let searchval = new FormData();
      searchval.append("keyword", search);
      this.apiService.searchMenu(searchval).subscribe((res) => {
        this.search_res = res['data'];
      });
      $('.search-list').show();
    } else {
      $('.search-list').hide();
      this.search_res = [];
    }

  }
  gotopage(link) {
    $('.search-list').hide();
    this.search_inp = '';
    this.router.navigate(['/' + link]);
  }


  loadDisplayUserData() {
    let data = this.coreService.getUserData('branch_name');
    this.branch_name = data ? data : '';
    this.up = this.coreService.getUserPrivilage();
    this.display_name = this.coreService.getUserData('branch_disp_name');
    this.display_code = this.coreService.getUserData('branch_code');
    this.user_name = this.coreService.getUserData('usr_name');
    this.usr_username = this.coreService.getUserData('usr_username');
    this.admin_notification = this.coreService.getUserData('admin_notification');
    this.cmpny = this.coreService.getUserData('cmpny');
  }

}
